import React from 'react'
import { css } from 'glamor'
import Button from '../../button'

function CloseButton({ closeToast, text }) {
  // const styles = css({
  //   position: 'relative',
  //   display: 'inline-block',
  //   padding: '10px 20px',
  //   width: 'auto',
  //   height: 'auto',
  //   objectPosition: 'center',
  //   margin: '0'
  //   color: 'rgb(79, 79, 79)',
  //   width: 'auto',
  //   height: 'auto',
  //   fontWeight: 'bold',
  //   fontSize: '18px',
  //   background: 'transparent',
  //   outline: 'none',
  //   border: 'none',
  //   padding: 0,
  //   cursor: 'pointer',
  //   opacity: '0.7',
  //   transition: '.3s ease',
  //   alignSelf: 'flex-end',
  //   ':hover, :focus': {
  //     opacity: 1,
  //},
  // })
  return (
    // <button
    //   {...styles}
    //   type="button"
    //   onClick={closeToast}
    //   aria-label={ariaLabel}
    // >
    // 	✖
    // </button>
    <Button type="button" gray style={{ margin: '5%' }} onClick={closeToast}>
      {text ? text : 'Cancel'}
    </Button>
  )
}

export default CloseButton
